module.exports = __webpack_public_path__ + "static/media/IMG_4584 wide top and splash back - Copy.7c682ba6.JPG";